<template>
  <div id="app">
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav>
    <router-view/> -->
    <router-view :key="key"/>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'AppMain',
  computed: {
    key () {
      return this.$route.path
    }
  },
  created () {
    this.getCategoryAction()
  },
  methods: {
    ...mapActions('system', ['getCategoryAction'])
  }
}
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

}
</style>
